export const EcosystemActivityItem = ({ activity }) => {
  return (
    <div style={styles.container}>
      <div style={styles.labelContainer}>{activity?.NAME}</div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    gap: 12,
    alignItems: 'center',
  },
  labelContainer: {
    flexGrow: 1,
  },
};
